<template>
  <hypto-popup :title="'Resend Invitation'">
    <template v-slot:body>
      <p>Are you sure you want to resend invitation to <b>{{inviteOptions.email}}</b>?</p>
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="resendInvitation">Confirm</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

import ApiServices from '@/services/api/users'
import { openPopup } from '@/utils/helpers'

export default {
  name: 'ResendInvitation',
  components: { HyptoPopup },
  props: {
    inviteOptions: Object
  },
  methods: {
    openPopup,
    resendInvitation () {
      ApiServices.resendInvitation({id: this.inviteOptions.id}).then(response => {
        if (response.success) {
          this.successToastMsg(response.message)
          this.openPopup(null)
        } else {
          this.errorToastMsg(response.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  p {
    font-size: 15px;
  }

  .mobile {
    text-align: left;
  }
</style>
